import React, { FC } from 'react'
//import { ButtonLink } from 'components/ButtonLink'
import { Card } from 'components/Card'
import { Heading } from 'components/Heading'
import { Text } from 'components/Text'
import { useTranslation } from 'react-i18next'
import { Icon } from 'components/Icon'
import { Stack } from 'components/Stack'
import { Flex } from 'components/Flex'
import { Logo } from 'features/shared/Logo'
import styles from './InternalError.module.scss'

export const InternalError: FC = (_props) => {
  const { t } = useTranslation()
  //<ButtonLink to="/dashboard">{t('internal_error.cta')}</ButtonLink>
  function irDashboard() {
    var url = String(window.location);
    var urlbool = url.includes("app");
    var url2 = null;

    if (urlbool) {
      url2 = "https://app.descifra.global"
    } else {
      url2 = "https://staging.descifra.global"
    }
    window.location.href = url2;
  }

  return (
    <Flex justify="center" align="center" className={styles.internalError}>
      <Card className={styles.card}>
        <Stack space="xlarge">
          <Stack space="small">
            <Heading>{t('internal_error.title')}</Heading>
            <Text>{t('internal_error.subtitle')}</Text>
          </Stack>
          <button className={styles.buttonLink} onClick={irDashboard}>Ir al Dashboard</button>
          <Logo />
        </Stack>
        <Icon name="flashlight-line" className={styles.icon} />
      </Card>
    </Flex>
  )
}

InternalError.displayName = 'InternalError'
